import { render } from "./ViewPlayers.vue?vue&type=template&id=a00ab4cc"
import script from "./ViewPlayers.vue?vue&type=script&lang=js"
export * from "./ViewPlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__